import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import './styles/Toast.css';
import Navbar from './components/Navbar';
import MainPage from './pages/MainPage';
import EventPage from './pages/EventPage';
import SubmissionPage from './pages/SubmissionPage';
import OrganizerPage from './pages/OrganizerPage';
import AccountPage from './pages/AccountPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DatenschutzPage from './pages/DatenschutzPage';
import ImpressumPage from './pages/ImpressumPage';
import FAQPage from './pages/FAQPage';
import './styles/App.css';

function App() {
  return (
    <ToastProvider>
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/event/:id" element={<EventPage />} />
              <Route path="/submit" element={<SubmissionPage />} />
              <Route path="/edit/:id" element={<SubmissionPage />} />
              <Route path="/organizer/:id" element={<OrganizerPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/faq" element={<FAQPage />} />
            </Routes>
          </main>
          <footer className="footer">
            <div className="footer-content">
              <div className="footer-links">
                <Link to="/datenschutz">Datenschutz</Link>
                <Link to="/impressum">Impressum</Link>
              </div>
              <p className="footer-copyright">&copy; 2026 WennWieWo</p>
              <div className="footer-social">
                <a href="https://www.instagram.com/wennwiewo/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="mailto:kontakt@wennwiewo.ch" aria-label="E-Mail">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </a>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </AuthProvider>
    </ToastProvider>
  );
}

export default App;
